import React from 'react';
import TextField from 'components/form-components/TextField';
import searchIcon from 'assets/images/icons/search.svg';
import PropTypes from 'prop-types';
import FormButton from 'components/form-components/FormButton';
import plusIcon from 'assets/images/icons/plus.svg';
import { useTranslation } from 'react-i18next';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const TicketTypesHeaders = ({
  filteringData,
  setFilteringData,
  debounceFunc,
  handleAddTicketType,
}) => {
  const { t } = useTranslation();
  return (
    <div className='p-3'>
      <span className='d-block theme-font-inter-bold theme-size-1_5'>{t('text_ticket_types')}</span>
      <span className='d-block theme-font-inter-medium'>{t('text_ticket_types_detail')}</span>
      <div className='mt-3 d-flex justify-content-between align-items-center'>
        <div className='d-flex gap-3'>
          <TextField
            value={filteringData['search'] ? filteringData['search'] : ''}
            name='search'
            handleChange={setFilteringData}
            placeholder='field_search'
            icon={searchIcon}
            debounceFunc={debounceFunc}
            shrink
          />
        </div>
        {isPermissionAvailable(permissionKeys.field_work_tickets_create) && (
          <FormButton
            text='button_add_type'
            variant='green-1'
            onClick={handleAddTicketType}
            icon={plusIcon}
            iconClasses='svg-white'
          />
        )}
      </div>
    </div>
  );
};

TicketTypesHeaders.propTypes = {
  filteringData: PropTypes.object.isRequired,
  setFilteringData: PropTypes.func.isRequired,
  debounceFunc: PropTypes.func.isRequired,
  handleAddTicketType: PropTypes.func.isRequired,
};

export default TicketTypesHeaders;
